import { alpha, Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Autocomplete(theme: Theme) {
    return {
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    '& span.MuiAutocomplete-tag': {
                        ...theme.typography.body2,
                        width: 24,
                        height: 24,
                        lineHeight: '24px',
                        textAlign: 'center',
                        borderRadius: theme.shape.borderRadius,
                        backgroundColor: alpha(theme.palette.grey[500], 0.16),
                    },
                    '& .MuiOutlinedInput-root .MuiAutocomplete-endAdornment': {
                        right: 'inherit',
                        insetInlineEnd: theme.spacing(0.5),
                    },
                    '& .MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
                        width: 'inherit',
                    },
                    marginTop: '0 !important',
                    '&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root':
                        {
                            paddingRight: 'inherit',
                            paddingInlineEnd: theme.spacing(8),
                            paddingInlineStart: theme.spacing(1.5),
                        },
                    '& .MuiOutlinedInput-root.MuiInputBase-sizeSmall': {
                        paddingleft: 'inherit',
                        paddingInlineStart: theme.spacing(0.75),
                    },
                },
                paper: {
                    boxShadow: theme.customShadows.dropdown,
                },
                listbox: {
                    padding: theme.spacing(0, 1),
                },
                option: {
                    ...theme.typography.body2,
                    padding: theme.spacing(1),
                    margin: theme.spacing(0.75, 0),
                    borderRadius: theme.shape.borderRadius,
                },
            },
        },
    };
}
